import React, {FC, useCallback, useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getSubscriptionsDetailsById } from '../../../../common/async/AsyncCalls';
import { PAYMENT_ACTION_TYPE } from '../../../../common/state/payments/payment';
import { IUserState } from '../../../../common/state/profile/user';
import { GENERAL_INFO_ACTION_TYPE, IGeneralInfo, IGeneralInfoState } from '../../../../common/state/subscriptions/general_info';
import { IPaymentInfo, IPaymentInfoState } from '../../../../common/state/subscriptions/payment_info';
import { IPersonalInfo, IPersonalInfoState, PERSONAL_INFO_ACTION_TYPE } from '../../../../common/state/subscriptions/personal_info';
import SimpleSpinner from '../../../../components/loaders/spinners/SimpleSpinner';
import NavbarAdmin from '../../../../components/navbar/Navbar.admin';
import SubscriptionEmailForm, { SubscriptionEmailFormData } from '../Subscription.email.admin';
import SubscriptionDetailsView from './Subscription.details';
// custom

const SubscriptionUpdateAdminView : FC = () => {
    const params: {id: string} = useParams();        
    // states    
    const token: string = useSelector(({user} : {user: IUserState}) => user.token);
    const [isLoading, toggleLoading] = useState(false);
    const payment_info: IPaymentInfo | undefined = useSelector(({payment_info} : {
        payment_info: IPaymentInfoState
    }) => payment_info.selected);
    const personal_info: IPersonalInfo | undefined = useSelector(({personal_info}: {
        personal_info: IPersonalInfoState}) => personal_info.selected);
    const general_info: IGeneralInfo | undefined = useSelector(({general_info}: {
        general_info: IGeneralInfoState}) => general_info.selected);

    // actions
    const paymentDispatch : (data : {type: PAYMENT_ACTION_TYPE, payload: any}) => void = useDispatch();
    const personalDispatch : (data : {type: PERSONAL_INFO_ACTION_TYPE, payload: any}) => void = useDispatch();
    const generalDispatch : (data : {type: GENERAL_INFO_ACTION_TYPE, payload: any}) => void = useDispatch();

    // evt handlers
    const handleFormSubmit = (data: SubscriptionEmailFormData) => {
        console.log('Form for submission: ', data);
    };

    const fetchSubscriptionDetailsById = useCallback(async () => {        
        if (!token || token === '') return;
        if (!params || !params.id) return;
        try {
            toggleLoading(true);
            const response = await getSubscriptionsDetailsById(token, params?.id);
            // console.log('Subscription details: ', response?.data);
            const details = response?.data;            
            paymentDispatch({type: PAYMENT_ACTION_TYPE.SELECT_PAYMENT, payload: details?.payment_info});
            personalDispatch({type: PERSONAL_INFO_ACTION_TYPE.INFO_SELECT, payload: details?.personal_info});
            generalDispatch({type: GENERAL_INFO_ACTION_TYPE.INFO_SELECT, payload: details?.general_info});
        } catch (err) {
            console.log('Error fetching subscription details: ', err);
            toast(`Error loading subscription page!`);
        } finally {
            toggleLoading(false);
        }
    }, [params, token]);

    useEffect(()=>{        
        fetchSubscriptionDetailsById();
    },[params]);
    return <React.Fragment>
        <NavbarAdmin/>
        <div
            className="flex flex-col items-start justify-start w-screen min-h-screen p-4 text-gray-700 bg-gray-200 lg:p-16 dark:bg-gray-800 dark:text-teal-400">
            <h2 className="mb-2 text-2xl text-gray-700 dark:text-teal-400">Next Best Action</h2>
            <p className="mb-4 text-gray-700 dark:text-gray-300 dartext-base">
                Update the status as "success" when triggering the registration letter
            </p>
            {isLoading ? <SimpleSpinner loading={isLoading} title={'Loading Subscription details...'}/> : <React.Fragment>
            <SubscriptionEmailForm 
                defaultFormData={{
                    certificate: '',
                    name: `${personal_info?.first_name} ${personal_info?.last_name}`                                      ,
                    email: personal_info?.email?? '',
                    status: general_info?.status?? 'initiated'
                }}
                onSubmit={handleFormSubmit}/>
                <SubscriptionDetailsView/>
            </React.Fragment>}               
        </div>
    </React.Fragment>
};

export default SubscriptionUpdateAdminView;